<template>
  <div class="col-12 cuestionario-container">
    <div class="p-fluid formgrid grid">
      <div class="field col-12">
        <div class="alerta-info">
          <i class="pi pi-info-circle icono-alerta"></i>
          <p class="texto-alerta">
            Responda <strong>SI</strong> o <strong>NO</strong> a cada pregunta. Este cuestionario será agregado a su
            ficha odontológica y es confidencial.
          </p>
        </div>
      </div>

      <!-- Columna izquierda -->
      <div class="field col-12 md:col-6">
        <div class="fila-pregunta">
          <span class="texto-pregunta">1. ¿Ha recibido tratamiento con algún especialista últimamente?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p1 === true }" @click="data.p1 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p1 === false }" @click="data.p1 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">2. ¿Tomó o está tomando algún medicamento? ¿Cuál?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p2 === true }" @click="data.p2 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p2 === false }" @click="data.p2 = false">
              NO
            </button>
          </div>
          <Textarea
            v-if="data.p2 === true"
            class="input-detalle"
            v-model="data.p2_cual"
            placeholder="Especifique el medicamento"
            rows="1"
            autoResize
          />
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta"
            >3. ¿Ha sufrido alguna intervención quirúrgica? ¿Ha estado internado alguna vez?</span
          >
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p3 === true }" @click="data.p3 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p3 === false }" @click="data.p3 = false">
              NO
            </button>
          </div>
          <Textarea
            v-if="data.p3 === true"
            class="input-detalle"
            v-model="data.p3_internado"
            placeholder="¿Ha estado internado alguna vez?"
            rows="1"
            autoResize
          />
        </div>

        <div class="fila-pregunta fila-multilinea">
          <span class="texto-pregunta">4. ¿Tuvo o tiene alguna de las siguientes enfermedades?</span>
          <div class="lista-compacta">
            a)Fiebre Reumática b)Enfermedades del Corazón c)Reumatismo Articular d)Asma e)Diabetes f)Epilepsia g)Presión
            Arterial h)Ataque Cardíaco i)Tuberculosis j)Ataque Cerebral k)Enfermedades Venéreas l)Hepatitis A, B o C
            m)SIDA n)Otros
          </div>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p4 === true }" @click="data.p4 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p4 === false }" @click="data.p4 = false">
              NO
            </button>
          </div>
          <Textarea
            v-if="data.p4 === true"
            class="input-detalle"
            v-model="data.p4_incisos"
            placeholder="Ingrese los incisos"
            rows="1"
            autoResize
          />
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">5. ¿Tuvo reacciones alérgicas? ¿A qué?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p5 === true }" @click="data.p5 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p5 === false }" @click="data.p5 = false">
              NO
            </button>
          </div>
          <Textarea
            v-if="data.p5 === true"
            class="input-detalle"
            v-model="data.p5_cual"
            placeholder="Especifique"
            rows="1"
            autoResize
          />
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">6. ¿Le sangran las heridas durante mucho tiempo?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p6 === true }" @click="data.p6 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p6 === false }" @click="data.p6 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">7. ¿Tiene familiares diabéticos?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p7 === true }" @click="data.p7 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p7 === false }" @click="data.p7 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">8. ¿Tuvo o tiene placas blancas en la boca, que se desprenden y duelen?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p8 === true }" @click="data.p8 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p8 === false }" @click="data.p8 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">9. ¿Tuvo fiebre por semanas sin causa justificada?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p9 === true }" @click="data.p9 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p9 === false }" @click="data.p9 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">10. ¿Se agita, tiene tos seca o dificultad para respirar?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p10 === true }" @click="data.p10 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p10 === false }" @click="data.p10 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">11. ¿Tuvo o tiene diarreas más de una semana sin causa?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p11 === true }" @click="data.p11 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p11 === false }" @click="data.p11 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">12. ¿Consume drogas, alcohol o tabaco?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p12 === true }" @click="data.p12 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p12 === false }" @click="data.p12 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">13. ¿Recibió algún tipo de transfusión en los últimos años?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p13 === true }" @click="data.p13 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p13 === false }" @click="data.p13 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">14. ¿Marido hemofílico?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p14 === true }" @click="data.p14 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p14 === false }" @click="data.p14 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">15. ¿Está Ud. embarazada?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p15 === true }" @click="data.p15 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p15 === false }" @click="data.p15 = false">
              NO
            </button>
          </div>
        </div>
      </div>

      <!-- Columna derecha -->
      <div class="field col-12 md:col-6">
        <div class="fila-pregunta">
          <span class="texto-pregunta">16. ¿Utiliza técnicas de control de natalidad?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p16 === true }" @click="data.p16 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p16 === false }" @click="data.p16 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">17. ¿Puede estar embarazada?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.p17 === true }" @click="data.p17 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.p17 === false }" @click="data.p17 = false">
              NO
            </button>
          </div>
        </div>

        <div class="titulo-seccion">Hábitos y Costumbres</div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">1. ¿Fuma? ¿Cuántas veces al día?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.h_p1 === true }" @click="data.h_p1 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.h_p1 === false }" @click="data.h_p1 = false">
              NO
            </button>
          </div>
          <Textarea
            v-if="data.h_p1 === true"
            class="input-detalle"
            v-model="data.h_p1_cual"
            placeholder="Especifique"
            rows="1"
            autoResize
          />
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">2. ¿Toma bebidas alcohólicas? ¿Con qué frecuencia?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.h_p2 === true }" @click="data.h_p2 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.h_p2 === false }" @click="data.h_p2 = false">
              NO
            </button>
          </div>
          <Textarea
            v-if="data.h_p2 === true"
            class="input-detalle"
            v-model="data.h_p2_cual"
            placeholder="Especifique"
            rows="1"
            autoResize
          />
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">3. ¿Duerme con la boca abierta?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.h_p3 === true }" @click="data.h_p3 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.h_p3 === false }" @click="data.h_p3 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">4. ¿Se muerde las uñas?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.h_p4 === true }" @click="data.h_p4 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.h_p4 === false }" @click="data.h_p4 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">5. ¿Se chupa los dedos?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.h_p5 === true }" @click="data.h_p5 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.h_p5 === false }" @click="data.h_p5 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">6. ¿Chupa lápices, agujas, clavos, etc.?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.h_p6 === true }" @click="data.h_p6 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.h_p6 === false }" @click="data.h_p6 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">7. ¿Sujeta algún elemento en su boca (pepa, agujas, etc.)?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.h_p7 === true }" @click="data.h_p7 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.h_p7 === false }" @click="data.h_p7 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">8. ¿Destapa botellas con los dientes?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.h_p8 === true }" @click="data.h_p8 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.h_p8 === false }" @click="data.h_p8 = false">
              NO
            </button>
          </div>
        </div>

        <div class="fila-pregunta">
          <span class="texto-pregunta">9. ¿Tiene algún otro hábito que considere importante? ¿Cuál?</span>
          <div class="botones-si-no">
            <button type="button" class="btn-si" :class="{ activo: data.h_p9 === true }" @click="data.h_p9 = true">
              SI
            </button>
            <button type="button" class="btn-no" :class="{ activo: data.h_p9 === false }" @click="data.h_p9 = false">
              NO
            </button>
          </div>
          <Textarea
            v-if="data.h_p9 === true"
            class="input-detalle"
            v-model="data.h_p9_cual"
            placeholder="Especifique"
            rows="1"
            autoResize
          />
        </div>

        <div class="alerta-final">
          <i class="pi pi-shield"></i>
          <span
            >En lo que a mí respecta, todas las respuestas son ciertas y correctas. Si alguna vez mi salud experimenta
            algún cambio, me comprometo a informar a mi Odontólogo.</span
          >
        </div>

        <div class="seccion-firma">
          <label class="label-firma"><i class="pi pi-pencil"></i> Firma Digital</label>
          <!-- Firma ya guardada: solo se muestra, NO se puede editar -->
          <div v-if="firmaGuardada">
            <img :src="firmaGuardada" alt="Firma" class="firma-img" />
            <p class="firma-nota"><i class="pi pi-lock"></i> Firma registrada. No editable.</p>
          </div>
          <!-- Sin firma: permite dibujar -->
          <div v-else class="canvas-wrapper">
            <canvas ref="canvas" class="canvas-cuestionario"></canvas>
            <Button label="Limpiar" icon="pi pi-times" class="p-button-text p-button-sm mt-1" @click="limpiarFirma()" />
          </div>
        </div>
      </div>
    </div>

    <div class="p-fluid formgrid grid justify-content-end mt-2">
      <div class="field col-12 md:col-2">
        <Button label="CANCELAR" icon="pi pi-times" class="p-button-danger p-button-sm" @click="cancelarEnvio()" />
      </div>
      <div class="field col-12 md:col-2">
        <Button
          label="IMPRIMIR"
          icon="pi pi-print"
          class="p-button-warning p-button-sm"
          @click="printCuestionario()"
          :loading="imprimiendo"
          :disabled="!data.id"
        />
      </div>
      <div class="field col-12 md:col-2">
        <Button
          :label="data.id ? 'ACTUALIZAR' : 'GUARDAR'"
          icon="pi pi-save"
          class="p-button-info p-button-sm"
          @click="saveCuestionario()"
          :loading="loading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CuestionarioService from '@/service/CuestionarioService'
import SignaturePad from 'signature_pad'

const CAMPOS_BOOL = [
  'p1',
  'p2',
  'p3',
  'p4',
  'p5',
  'p6',
  'p7',
  'p8',
  'p9',
  'p10',
  'p11',
  'p12',
  'p13',
  'p14',
  'p15',
  'p16',
  'p17',
  'h_p1',
  'h_p2',
  'h_p3',
  'h_p4',
  'h_p5',
  'h_p6',
  'h_p7',
  'h_p8',
  'h_p9'
]

export default {
  emits: ['actualizarListado'],
  props: {
    cuestionario_personal: { type: [Object, Array], default: () => ({}) },
    cliente_id: { type: Number, default: 0 }
  },
  cuestionarioService: null,
  created() {
    this.cuestionarioService = new CuestionarioService()
  },
  data() {
    return {
      data: {},
      data_cliente_id: this.cliente_id,
      loading: false,
      signaturePad: null,
      firmaGuardada: '',
      imprimiendo: false
    }
  },
  mounted() {
    this.mapearDatos(this.cuestionario_personal)
  },
  methods: {
    mapearDatos(val) {
      let datos = val
      if (val?.cuestionario_personal) datos = val.cuestionario_personal
      if (Array.isArray(datos)) datos = datos[0] ?? {}
      datos = datos ?? {}

      this.data = { ...datos }
      this.firmaGuardada = datos.firma || ''

      CAMPOS_BOOL.forEach((campo) => {
        const valor = datos[campo]
        if (valor === 1 || valor === '1' || valor === true) this.data[campo] = true
        else if (valor === 0 || valor === '0' || valor === false) this.data[campo] = false
        else this.data[campo] = null
      })

      // Solo inicializar canvas si NO hay firma guardada
      if (!this.firmaGuardada) {
        this.$nextTick(() => this.inicializarFirma())
      }
    },
    inicializarFirma() {
      this.$nextTick(() => {
        const canvas = this.$refs.canvas
        if (canvas) {
          canvas.width = canvas.offsetWidth || 500
          canvas.height = 150
          this.signaturePad = new SignaturePad(canvas)
        }
      })
    },
    printCuestionario() {
      this.imprimiendo = true
      this.cuestionarioService.imprimirCuestionario({ cliente_id: this.data_cliente_id }).then(() => {
        this.imprimiendo = false
      })
    },
    limpiarFirma() {
      if (this.signaturePad) this.signaturePad.clear()
    },
    saveCuestionario() {
      this.loading = true

      let datosConvertidos = { ...this.data }
      CAMPOS_BOOL.forEach((campo) => {
        if (datosConvertidos[campo] === true) datosConvertidos[campo] = 1
        else if (datosConvertidos[campo] === false) datosConvertidos[campo] = 0
        else datosConvertidos[campo] = null
      })

      // Firma: si ya hay guardada la mantiene; si no, toma la nueva dibujada
      let firmaFinal = this.firmaGuardada || null
      if (!this.firmaGuardada && this.signaturePad && !this.signaturePad.isEmpty()) {
        firmaFinal = this.signaturePad.toDataURL('image/png')
      }

      let datos = {
        ...datosConvertidos,
        cliente_id: this.data_cliente_id,
        firma: firmaFinal
      }

      this.cuestionarioService.saveCuestionario(datos).then((response) => {
        if (response.success == false) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 })
        } else {
          this.$toast.add({ severity: 'success', summary: 'Éxito', detail: response.message, life: 3000 })
          this.$emit('actualizarListado')
        }
        this.loading = false
      })
    },
    cancelarEnvio() {
      this.imprimiendo = false
    }
  },
  watch: {
    cliente_id(val) {
      this.data_cliente_id = val
    },
    cuestionario_personal: {
      handler(val) {
        this.mapearDatos(val)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';

.cuestionario-container {
  background: #ffffff;
  font-size: 1rem;
}

.alerta-info {
  display: flex;
  align-items: center;
  background: #f4fafc;
  border-left: 4px solid #5eaac0;
  padding: 8px 12px;
  border-radius: 5px;
  margin-bottom: 6px;
}
.icono-alerta {
  color: #3d8ba3;
  font-size: 1.2rem;
  margin-right: 8px;
}
.texto-alerta {
  font-size: 0.95rem;
  color: #2c5866;
  margin: 0;
}

.fila-pregunta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 4px;
  border-bottom: 1px solid #eef2f4;
  flex-wrap: wrap;
  gap: 5px;
}

.fila-multilinea {
  flex-direction: column;
  align-items: stretch;
}

.texto-pregunta {
  font-size: 1rem;
  font-weight: 700;
  color: #263238;
  flex: 1;
  min-width: 180px;
}

.lista-compacta {
  font-size: 0.85rem;
  font-weight: 500;
  color: #607d8b;
  background: #f7f9fa;
  padding: 6px 10px;
  border-radius: 4px;
  margin: 5px 0;
  line-height: 1.6;
}

.botones-si-no {
  display: flex;
  gap: 5px;
  flex-shrink: 0;
}

.btn-si,
.btn-no {
  min-width: 38px;
  padding: 3px 11px;
  font-size: 0.82rem;
  font-weight: 700;
  border-radius: 4px;
  border: 1.5px solid;
  cursor: pointer;
  background: white;
  transition: all 0.15s ease;
  line-height: 1.4;
}

.btn-si {
  color: #3d9b98;
  border-color: #a3d5d1;

  &:hover {
    background: #eefaf9;
  }

  &.activo {
    background: #4db6ac;
    color: white;
    border-color: #3d9b98;
  }
}

.btn-no {
  color: #c97b6e;
  border-color: #e6b8b0;

  &:hover {
    background: #fdf4f2;
  }

  &.activo {
    background: #d98b7e;
    color: white;
    border-color: #c97b6e;
  }
}

.input-detalle {
  width: 100%;
  padding: 5px 10px;
  border: 1.5px solid #b8dde5;
  border-radius: 4px;
  background: #ffffff;
  font-size: 0.9rem;
  margin-top: 5px;

  &:focus {
    outline: none;
    border-color: #5eaac0;
  }
}

.titulo-seccion {
  margin: 10px 0 4px 0;
  padding: 6px 12px;
  background: #f4fafc;
  border-left: 4px solid #5eaac0;
  border-radius: 4px;
  font-weight: 700;
  font-size: 1rem;
  color: #2c5866;
}

.alerta-final {
  display: flex;
  align-items: center;
  gap: 7px;
  background: #ffffff;
  border: 1px solid #d4e9ed;
  border-left: 4px solid #4db6ac;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 10px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #35635c;

  i {
    color: #4db6ac;
  }
}

.seccion-firma {
  margin-top: 10px;
}
.label-firma {
  display: block;
  font-weight: 700;
  font-size: 0.95rem;
  color: #263238;
  margin-bottom: 5px;
}
.firma-img {
  border: 1.5px solid #5eaac0;
  border-radius: 4px;
  width: 100%;
  max-width: 500px;
  height: auto;
}
.firma-nota {
  font-size: 0.8rem;
  color: #16a34a;
  margin-top: 4px;

  i {
    margin-right: 4px;
  }
}
.canvas-wrapper {
  width: 100%;
  max-width: 500px;
}
.canvas-cuestionario {
  border: 1.5px dashed #a3c4cf;
  border-radius: 4px;
  width: 100% !important;
  height: 150px;
  display: block;
  cursor: crosshair;
}
</style>